
const timers = {
  run: { key: 'run', id: 0, time: 6000 },
  stop: { key: 'stop', id: 0, time: 6000 },
  test: { key: 'test', id: 0, time: 6000 },
  testEnd: { key: 'testEnd', id: 0, time: 36000, desc: '等待socket测试结果返回' },
  testGetEnd: { key: 'testGetEnd', id: 0, time: 1500, desc: 'http轮询测试结果返回' },
  commit: { key: 'commit', id: 0, time: 6000 },
  // httpGetOutput
  getOutput: { key: 'getOutput', id: 0, time: 1000 },
}

const clearTimer = key => {
  if (timers[key] && timers[key].id) {
    clearTimeout(timers[key].id);
    timers[key].id = 0;
    timers[key].startT = 0;
  }
}

const setTimer = (callback, time, key, param) => {
  if (timers[key]) {
    clearTimer(key);
  } else {
    timers[key] = {};
  }
  timers[key].id = setTimeout(callback, time, param);
  timers[key].startT = Date.now();
}

const getTime = key => {
  if (timers[key] && timers[key].startT) {
    return (Date.now() - timers[key].startT) || 1
  }
  return 0
}

export default {
  timers,
  clearTimer,
  setTimer,
  getTime
};
